<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Nakliyeci Sınıfı Ana Grubu</label>
            <v-validator :errors="errors" parameter="ParentCarrierClassificationId" :watch="carrierClassification">
                <v-select-list v-model="carrierClassification" placeholder="Nakliyeci Sınıfı Ana Grubu" label="Name" :options="c_carrierClassifications"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Nakliyeci Sınıfı</label>
            <input type="text" class="form-control" placeholder="Nakliyeci Sınıfı" v-model="value.Name">
        </div>
    </div>
</template>

<script>
import CarrierClassificationApi from '@/api/operational-parameters'
export default {
    props:{
        value:Object,
        errors:Object
    },
    components:{
        CarrierClassificationApi
    },
    mounted(){
        this.getCarrierClassifications();
    },
    data(){
        return{
            carrierClassifications:[],
        }
    },
    methods:{
        getCarrierClassifications(){
            CarrierClassificationApi.CarrierClassification.List()
            .then(res=>{
                this.carrierClassifications = res.data.Data
            })
        },
    },
    computed:{
        c_carrierClassifications(){
            return this.carrierClassifications.filter(carrierClassification => carrierClassification.Id != this.value.Id)
        },
        carrierClassification:{
            get:function(){
                return this.carrierClassifications.find(b=>b.Id==this.value.ParentCarrierClassificationId)
            },
            set:function(value){
                this.value.ParentCarrierClassificationId = value?.Id || this.value.ParentCarrierClassificationId
            }
        }
    }
}
</script>

<style lang="scss">
</style>